import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import 'remixicon/fonts/remixicon.css'

export default function Footer() {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  }

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <motion.div {...fadeInUp}>
            <img src="/logo.png" alt="Ami Bites" className="h-16 mb-4 object-contain" style={{ backgroundColor: 'transparent' }} />
            <p className="text-gray-400 text-sm mb-4">
              Zimbabwe's leading food ordering and delivery platform. Order quality meals from trusted restaurants.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-600 rounded-full flex items-center justify-center hover:bg-orange-700 transition-colors">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} transition={{ delay: 0.1 }}>
            <h3 className="text-lg font-bold mb-4 text-gradient">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-orange-400 transition-colors">Home</Link></li>
              <li><Link to="/order" className="text-gray-400 hover:text-orange-400 transition-colors">Order Now</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors">Our Services</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors">About Us</Link></li>
              <li><Link to="/partner-with-us" className="text-gray-400 hover:text-orange-400 transition-colors">Become a Partner</Link></li>
            </ul>
          </motion.div>

          <motion.div {...fadeInUp} transition={{ delay: 0.2 }}>
            <h3 className="text-lg font-bold mb-4 text-gradient">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-xl flex-shrink-0 mt-1 !text-orange-400"></i>
                <span className="text-gray-400 text-sm">36 Deacon Drive, Philadelphia, Hogerty Hill, Harare, Zimbabwe</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-xl !text-orange-400"></i>
                <a href="tel:+16838886864" className="text-gray-400 hover:text-orange-400 transition-colors">+1 (683) 888-6864</a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-xl !text-orange-400"></i>
                <a href="mailto:info@amibites.com" className="text-gray-400 hover:text-orange-400 transition-colors">info@amibites.com</a>
              </li>
            </ul>
          </motion.div>

          <motion.div {...fadeInUp} transition={{ delay: 0.3 }}>
            <h3 className="text-lg font-bold mb-4 text-gradient">Download Our App</h3>
            <p className="text-gray-400 text-sm mb-4">Order food anytime, anywhere</p>
            <div className="space-y-3">
              <a 
                href="https://play.google.com/store/apps/details?id=amibites.com.myapp&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-black hover:bg-gray-800 text-white px-4 py-3 rounded-lg flex items-center justify-center space-x-3 transition-colors group"
              >
                <i className="ri-smartphone-line text-xl group-hover:scale-110 transition-transform"></i>
                <div className="text-left">
                  <div className="text-xs text-gray-400">Get it on</div>
                  <div className="font-semibold">Google Play</div>
                </div>
              </a>
              <button className="w-full bg-black hover:bg-gray-800 text-white px-4 py-3 rounded-lg flex items-center justify-center space-x-3 transition-colors opacity-60 cursor-not-allowed" disabled>
                <i className="ri-smartphone-line text-xl"></i>
                <div className="text-left">
                  <div className="text-xs text-gray-400">Download on the</div>
                  <div className="font-semibold">App Store</div>
                </div>
              </button>
            </div>
          </motion.div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Ami Bites.<br />
              Ami Bites is a member of the Pitch For Me Group of Companies. Committed to excellence, innovation, and service delivery across industries.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/data-protection" className="text-gray-400 hover:text-orange-400 transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-gray-400 hover:text-orange-400 transition-colors">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
